import { Box, Heading } from "@chakra-ui/react";
import ReactGA from "react-ga4";

function Terms(){
    ReactGA.send({
    hitType: "pageview",
    page: "/termsofuse",
    title: "Terms of Use",
  });
  return (
    <Box
        bgColor='white'
        overflow='hidden'
        minH='500px'
        borderRadius='16px'
        my='40px'
        style={{ opacity: 0.9 }}
      >
        <Heading
          alignItems='center'
          justifyContent='space-between'
          display='flex'
          p='16px'
          bgColor='primary'
          fontSize='4xl'
        >
          TERMS OF USE
        </Heading>
        <div style={{ 
          maxWidth: '1200px', 
          paddingLeft: '32px', 
          backgroundColor: 'white', 
        }}>
          <div style={{ marginTop: '24px' }}>
              <p style={{ 
                fontSize: '14px', 
                color: '#6B7280', 
                marginBottom: '24px' 
              }}>
                  <strong>Effective Date: </strong>July 22, 2025
              </p>
              
              <p style={{ marginBottom: '24px' }}>
                  Welcome to <strong>leaderbored.gg</strong>, owned and operated by <strong>Cadre Creative Labs OPC</strong> ("we," "our," or "us"). By accessing and using leaderbored.gg, you agree to be bound by these Terms of Use ("Terms"). Please read them carefully before using our website.
              </p>

              <section style={{ marginBottom: '32px' }}>
                  <h2 style={{ 
                    fontSize: '32px', 
                    fontWeight: '600', 
                    color: '#1F2937', 
                    marginBottom: '16px' 
                  }}>1. Acceptance of Terms</h2>
                  <p>
                      By using leaderbored.gg, you confirm that you are at least <strong>13 years old</strong> and legally capable of agreeing to these Terms. If you do not agree with any part of these Terms, please do not use the site.
                  </p>
              </section>

              <section style={{ marginBottom: '32px' }}>
                  <h2 style={{ 
                    fontSize: '32px', 
                    fontWeight: '600', 
                    color: '#1F2937', 
                    marginBottom: '16px' 
                  }}>2. Use of Our Services</h2>
                  <p style={{ marginBottom: '12px' }}>
                      leaderbored.gg provides casual games, leaderboards, comics, and other interactive content for entertainment purposes. You agree to:
                  </p>
                  <ul style={{ listStyleType: 'disc', paddingLeft: '24px' }}>
                      <li style={{ marginBottom: '8px' }}>Use the site only for lawful purposes.</li>
                      <li style={{ marginBottom: '8px' }}>Not attempt to hack, exploit, or disrupt the services.</li>
                      <li style={{ marginBottom: '8px' }}>Respect other users and avoid abusive or harmful behavior.</li>
                  </ul>
              </section>

              <section style={{ marginBottom: '32px' }}>
                  <h2 style={{ 
                    fontSize: '32px', 
                    fontWeight: '600', 
                    color: '#1F2937', 
                    marginBottom: '16px' 
                  }}>3. User Accounts</h2>
                  <ul style={{ listStyleType: 'disc', paddingLeft: '24px' }}>
                      <li style={{ marginBottom: '8px' }}>You may be required to create an account to participate in leaderboards or prize contests.</li>
                      <li style={{ marginBottom: '8px' }}>You are responsible for maintaining the confidentiality of your account information.</li>
                      <li style={{ marginBottom: '8px' }}>You agree to provide accurate information when registering and to update it as needed.</li>
                  </ul>
              </section>

              <section style={{ marginBottom: '32px' }}>
                  <h2 style={{ 
                    fontSize: '32px', 
                    fontWeight: '600', 
                    color: '#1F2937', 
                    marginBottom: '16px' 
                  }}>4. Leaderboards, Prizes, and Promotions</h2>
                  <ul style={{ listStyleType: 'disc', paddingLeft: '24px' }}>
                      <li style={{ marginBottom: '8px' }}>Leaderboard rankings are based on your in-game performance and may be subject to verification.</li>
                      <li style={{ marginBottom: '8px' }}>Promotions or prize giveaways are governed by their own specific rules and may have eligibility requirements.</li>
                      <li style={{ marginBottom: '8px' }}>We reserve the right to cancel, modify, or disqualify entries if fraudulent or abusive behavior is detected.</li>
                  </ul>
              </section>

              <section style={{ marginBottom: '32px' }}>
                  <h2 style={{ 
                    fontSize: '32px', 
                    fontWeight: '600', 
                    color: '#1F2937', 
                    marginBottom: '16px' 
                  }}>5. Intellectual Property</h2>
                  <p style={{ marginBottom: '12px' }}>
                      All content on leaderbored.gg—including games, graphics, logos, comics, and text—is owned by <strong>Cadre Creative Labs OPC</strong> or its licensors.
                  </p>
                  <ul style={{ listStyleType: 'disc', paddingLeft: '24px' }}>
                      <li>You may not copy, reproduce, distribute, or create derivative works from any content without prior written permission.</li>
                  </ul>
              </section>

              <section style={{ marginBottom: '32px' }}>
                  <h2 style={{ 
                    fontSize: '32px', 
                    fontWeight: '600', 
                    color: '#1F2937', 
                    marginBottom: '16px' 
                  }}>6. Advertisements and Third-Party Services</h2>
                  <ul style={{ listStyleType: 'disc', paddingLeft: '24px' }}>
                      <li style={{ marginBottom: '8px' }}>Our site uses <strong>Google Analytics</strong>, <strong>Google AdSense</strong>, <strong>Playgab</strong>, and other third-party services for analytics, advertising, and prize rewards.</li>
                      <li style={{ marginBottom: '8px' }}>We are not responsible for third-party websites, content, or services linked through our platform.</li>
                  </ul>
              </section>

              <section style={{ marginBottom: '32px' }}>
                  <h2 style={{ 
                    fontSize: '32px', 
                    fontWeight: '600', 
                    color: '#1F2937', 
                    marginBottom: '16px' 
                  }}>7. Limitation of Liability</h2>
                  <p style={{ marginBottom: '12px' }}>
                      To the fullest extent permitted by law, leaderbored.gg and <strong>Cadre Creative Labs OPC</strong> are not liable for any direct, indirect, incidental, or consequential damages arising from your use of the site.
                  </p>
                  <p>
                      We do not guarantee uninterrupted access or error-free services.
                  </p>
              </section>

              <section style={{ marginBottom: '32px' }}>
                  <h2 style={{ 
                    fontSize: '32px', 
                    fontWeight: '600', 
                    color: '#1F2937', 
                    marginBottom: '16px' 
                  }}>8. Privacy</h2>
                  <p>
                      Your privacy is important to us. Please review our{" "}
                      <a 
                          href="/privacypolicy" 
                          style={{ 
                            color: '#2563EB', 
                            textDecoration: 'underline', 
                            fontWeight: '500' 
                          }}
                      >
                          Privacy Policy
                      </a>{" "}
                      to understand how we collect, use, and protect your information.
                  </p>
              </section>

              <section style={{ marginBottom: '32px' }}>
                  <h2 style={{ 
                    fontSize: '32px', 
                    fontWeight: '600', 
                    color: '#1F2937', 
                    marginBottom: '16px' 
                  }}>9. Changes to the Terms</h2>
                  <p>
                      We may update these Terms from time to time. Continued use of leaderbored.gg after changes are posted means you accept the updated Terms.
                  </p>
              </section>

              <section style={{ marginBottom: '32px' }}>
                  <h2 style={{ 
                    fontSize: '32px', 
                    fontWeight: '600', 
                    color: '#1F2937', 
                    marginBottom: '16px' 
                  }}>10. Governing Law</h2>
                  <p>
                      These Terms are governed by the laws of the <strong>Republic of the Philippines</strong>. Any disputes will be resolved under Philippine law.
                  </p>
              </section>

              <section style={{ marginBottom: '32px' }}>
                  <h2 style={{ 
                    fontSize: '32px', 
                    fontWeight: '600', 
                    color: '#1F2937', 
                    marginBottom: '16px' 
                  }}>11. Contact Us</h2>
                  <p>
                      If you have any questions or concerns about these Terms, please contact us at:{" "}
                      <a 
                          href="mailto:support@cadrecreativelabs.com" 
                          style={{ 
                            color: '#2563EB', 
                            textDecoration: 'underline', 
                            fontWeight: '500' 
                          }}
                      >
                          support@cadrecreativelabs.com
                      </a>
                  </p>
              </section>
          </div>
        </div>
    </Box>
  )
}
export default Terms;